import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface preferredHospital {
    id: string,
    hospitalName: string,
    distance: string
}
interface contact {
    name: string | null
    email: string,
    mobile: {
        countryCode: Number,
        number: Number
    }
}

interface Doctor {
    isAvailable: Boolean,
    doctorName: String,
    doctorNumber: {
        countryCode: Number,
        number: Number
    }
}


interface Nurse {
    isAvailable: Boolean,
    nurseName: String,
    nurseNumber: {
        countryCode: Number,
        number: Number
    }
}

interface AmbulanceAvailability {
    isAvailable: Boolean,
    ambulanceProviderName: String,
    ambulanceProviderNumber: {
        countryCode: Number,
        number: Number
    }
}

interface officeState {
    _id: string | null,
    companyId: string | null,
    doctorDetails: Doctor | null,
    nurseDetails: Nurse | null,
    ambulanceAvailability: AmbulanceAvailability | null,
    preferredHospital: preferredHospital[] | null,
    officeContacts: contact[] | null,
    messageContacts: contact[] | null,
    address: any,
    cords: any

}

const initialState: officeState = {
    _id: null,
    companyId: null,
    doctorDetails: null,
    nurseDetails: null,
    ambulanceAvailability: null,
    preferredHospital: null,
    officeContacts: null,
    messageContacts: null,
    address: null,
    cords: null


}

const officeSlice = createSlice({
    name: "office",
    initialState,
    reducers: {
        setOfficeReqInfo(state, action: PayloadAction<officeState>) {
            state._id = action.payload._id;
            state.companyId = action.payload.companyId;
            state.doctorDetails = action.payload.doctorDetails;
            state.nurseDetails = action.payload.nurseDetails;
            state.ambulanceAvailability = action.payload.ambulanceAvailability;
            state.preferredHospital = action.payload.preferredHospital;
            state.officeContacts = action.payload.officeContacts;
            state.messageContacts = action.payload.messageContacts;
            state.address = action.payload.address;
            state.cords = action.payload.cords;
        },
        resetOfficeReqInfo(state) {
            state._id = null;
            state.companyId = null;
            state.doctorDetails = null;
            state.nurseDetails = null;
            state.ambulanceAvailability = null;
            state.preferredHospital = null
            state.officeContacts = null;
            state.messageContacts = null;
            state.address = null;
            state.cords = null;
        },
    },
})

export const { setOfficeReqInfo, resetOfficeReqInfo } = officeSlice.actions;
export default officeSlice.reducer;